import { NavigationType } from 'react-router-dom';

const SCROLL_LOCK_KEYS = new Set([
  ' ',
  'ArrowDown',
  'ArrowUp',
  'End',
  'Home',
  'PageDown',
  'PageUp',
  'Spacebar',
]);
let scrollBehaviorRestoreFrame = 0;

export const isScrollLockKey = (key: string) => {
  return SCROLL_LOCK_KEYS.has(key);
};

export const getDocumentScrollTop = () => {
  if (typeof document === 'undefined') return 0;

  const scrollingElement = document.scrollingElement;
  return scrollingElement ? scrollingElement.scrollTop : window.scrollY;
};

export const getRestoredScrollTop = (
  navigationType: NavigationType,
  savedScrollTop: number | undefined,
) => {
  if (navigationType !== NavigationType.Pop) {
    return 0;
  }

  return savedScrollTop ?? 0;
};

export const restoreDocumentScrollTop = (scrollTop: number) => {
  if (typeof document === 'undefined') return;

  const scrollingElement = document.scrollingElement;
  const documentElement = document.documentElement;
  const previousScrollBehavior = documentElement.style.scrollBehavior;

  if (scrollBehaviorRestoreFrame !== 0) {
    window.cancelAnimationFrame(scrollBehaviorRestoreFrame);
    scrollBehaviorRestoreFrame = 0;
  }

  documentElement.style.scrollBehavior = 'auto';

  if (scrollingElement) {
    scrollingElement.scrollTop = scrollTop;
  }

  window.scrollTo(0, scrollTop);

  scrollBehaviorRestoreFrame = window.requestAnimationFrame(() => {
    documentElement.style.scrollBehavior = previousScrollBehavior;
    scrollBehaviorRestoreFrame = 0;
  });
};
